export default __webpack_public_path__ + "static/media/cloud-computing.d4f03300.png";